import { AnyPartItem } from "../stores/slices/cartSlice";

export const getMsrp = (product: AnyPartItem | null): string | undefined =>
  product?.partPricing.primaryPart.price["1"]?.contextList[0]?.listPrice;
